import { ExportIterator, DataSources } from '@leverege/ui-attributes';
import { DateTimeRangePicker } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
export default class ApiServerHistoryItemIterator extends ExportIterator {
  constructor(opts) {
    super();
    const {
      perPage,
      filter,
      range,
      where,
      ...rest
    } = opts;
    this.delegate = opts.delegate;
    this.perPage = opts.perPage || 100;
    this.filter = filter;
    this.range = range || DateTimeRangePicker.getRange('last7Days');
    this.where = where || undefined;
    this.options = rest;
    this.page = 0;
  }
  createDataItems = item => {
    const ref = `${this.delegate.getInterfaceUrl()}/${item.deviceId}.history`;
    const dataRef = {
      id: item.id,
      ref,
      type: this.options.objectType,
      data: item
    };
    const obj = DataSources.withData(dataRef);
    if (obj.data == null) {
      obj.data = item;
    }
    return JSON.parse(JSON.stringify(obj));
  };
  async next(retries = 5) {
    const q = {
      perPage: this.perPage,
      startIndex: this.page * this.perPage,
      order: [['$time', 'DESC']],
      where: this.where,
      ...this.range
    };
    try {
      const res = await GlobalState.dispatch(this.delegate.historyDelegate.search({
        query: q,
        queryName: 'historyCsvExport'
      }));
      this.nextToken = res.nextToken || null;
      this.page++;
      return res.items.map(this.createDataItems);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      if (retries > 0) {
        return this.next(retries - 1);
      }
      throw err;
    }
  }
  hasNext(lastRes) {
    return lastRes == null || lastRes?.length === this.perPage;
  }
}